export const product_taxonomies = ['product_cat', 'team', 'condition', 'sports', 'manufacturer', 'c_year', 'player'];
export const site_base = 'https://tonyetrade.com/';